import BaseApiRequest from "./BaseApiRequest";
import { PLAIN_GET_TOKEN } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class PlaidGetTokenRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = {};

  constructor(requestData) {
    super();
    this.body = { ...this.body, ...requestData };
  }

  getMethod = () => this.method;

  getUrl = () => PLAIN_GET_TOKEN;

  getBody = () => this.body;
}
